import { Button, Modal, Checkbox } from 'antd';
import { useEffect, useState } from 'react';
import { useAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';
import { useAsyncEffect, useRequest } from 'ahooks';
import { atomRequestCustomerDetail } from '@/App';
import { request } from '@/config/request';
import { toTheCkb, isLogin } from '@/config/request/login';
import styles from './index.module.scss';
interface Props {
    showModal: Boolean;
    onShowModalChange: (newShowModal: boolean) => void;
    productCode: string;
}
const ToAgentProcurement = ({ showModal, onShowModalChange, productCode }) => {
    const [customerDetail] = useAtom(atomRequestCustomerDetail);
    const [checkboxSelected, setCheckboxSelected] = useState(false);
    const [showModalWithSign, setShowModalWithSign] = useState(false);
    const {
        data: modalSign,
        runAsync: getCustomer2AgencyGoodsSign,
        loading
    } = useRequest(
        request.customer.getCustomer2AgencyGoodsSign
            .getCustomer2AgencyGoodsSign,
        {
            manual: true
        }
    );
    const { data: updateModalSign, runAsync: updateCustomer2AgencyGoodsSign } =
        useRequest(
            request.customer.updateCustomer2AgencyGoodsSign
                .updateCustomer2AgencyGoodsSign,
            {
                manual: true
            }
        );
    useAsyncEffect(async () => {
        // const sessionShowModalProductCode = window.sessionStorage.getItem(
        //     'showDirectToAgentModalProductCode'
        // );
        if (!showModal || !isLogin()) {
            return;
        }
        const res = await getCustomer2AgencyGoodsSign();
        if (res.data) {
            stayCurrent();

            // if (sessionShowModalProductCode) {
            //     window.sessionStorage.removeItem(
            //         'showDirectToAgentModalProductCode'
            //     );
            //     window.open(
            //         toTheCkb(
            //             `/ja/goods/${sessionShowModalProductCode}?directToAgent=true`
            //         )
            //     );
            //     return;
            // }
            window.open(
                toTheCkb(`/ja/goods/${productCode}?directToAgent=true`)
            );
        } else {
            setShowModalWithSign(true);
        }
    }, [getCustomer2AgencyGoodsSign, showModal]);
    const stayCurrent = () => {
        setCheckboxSelected(false);
        onShowModalChange(false);
        setShowModalWithSign(false);
    };
    const toAgent = async () => {
        checkboxSelected && (await updateCustomer2AgencyGoodsSign());
        // const sessionShowModalProductCode = window.sessionStorage.getItem(
        //     'showDirectToAgentModalProductCode'
        // );
        stayCurrent();
        // if (sessionShowModalProductCode) {
        //     window.sessionStorage.removeItem(
        //         'showDirectToAgentModalProductCode'
        //     );
        //     window.open(
        //         toTheCkb(
        //             `/ja/goods/${sessionShowModalProductCode}?directToAgent=true`
        //         )
        //     );
        //     return;
        // }
        window.open(toTheCkb(`/ja/goods/${productCode}?directToAgent=true`));
    };
    return (
        <>
            <Modal
                title=""
                open={showModalWithSign}
                className={styles.agentModal}
                footer={null}
                closable={false}
            >
                <div className={styles.modalWrap}>
                    <p className={styles.tip}>
                        {window._$m.t('该商品为代采会员特惠商品')}
                    </p>
                    <div className={styles.desc}>
                        <span className={styles.direct}>
                            {window._$m.t('直売モール')}
                        </span>
                        {window._$m.t('から')}
                        <span className={styles.agent}>
                            {window._$m.t('代理購入モール')}
                        </span>
                        {window._$m.t('へ')}
                    </div>
                    <div className={styles.illustration}>
                        <img
                            className={styles.direct}
                            src="https://static-s.theckb.com/BusinessMarket/Easy/PC/directToAgent_direct2.png"
                            alt="direct"
                        />
                        <div className={styles.mark}>
                            <div className={styles.schedule} />
                            <img
                                className={styles.aircraft}
                                src="https://static-s.theckb.com/BusinessMarket/Easy/PC/aircraft.png"
                                alt="aircraft"
                            />
                        </div>

                        <img
                            className={styles.agent}
                            src="https://static-s.theckb.com/BusinessMarket/Easy/PC/directToAgent_agent2.png"
                            alt="agent"
                        />
                    </div>
                    {/* 会员优惠 */}
                    <div className={styles.explanation}>
                        <div className={styles.nonMember}>
                            <div className={styles.title}>
                                <img
                                    className={styles.icon}
                                    src="https://static-s.theckb.com/BusinessMarket/Easy/PC/nonVip.png"
                                    alt="nonVip"
                                />
                                <p className={styles.txt}>
                                    {window._$m.t(
                                        '日常生活のニーズに応えるコスパ最高の買い物体験！'
                                    )}
                                </p>
                            </div>
                            <div className={styles.condition}>
                                <div className={styles.item}>
                                    {window._$m.t(
                                        '日本市場価格より安く購入可能'
                                    )}
                                </div>
                                <div className={styles.item}>
                                    {window._$m.t(
                                        '事前チャージ不要、買い物を個人で楽しむ'
                                    )}
                                </div>
                                <div className={styles.item}>
                                    {window._$m.t(
                                        'Global F Drop　厳選グローバル商品'
                                    )}
                                </div>
                                <div className={styles.item}>
                                    {window._$m.t('日本検品基準')}
                                </div>
                                <div className={styles.item}>
                                    {window._$m.t(
                                        '安心・スピードグローバル配送'
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={styles.member}>
                            <div className={styles.title}>
                                <img
                                    className={styles.icon}
                                    src="https://static-s.theckb.com/BusinessMarket/Easy/PC/vip.png"
                                    alt="vip"
                                />
                                <p className={styles.txt}>
                                    {window._$m.t(
                                        'EC販売事業を支援(有料会員制)'
                                    )}
                                </p>
                            </div>
                            <div className={styles.condition}>
                                <div className={styles.item}>
                                    {window._$m.t(
                                        '激安工場直売価格で代理購入、転売で稼ぐことも可能'
                                    )}
                                </div>
                                <div className={styles.item}>
                                    {window._$m.t(
                                        '知人や友人を紹介して報酬を獲得'
                                    )}
                                </div>
                                <div className={styles.item}>
                                    {window._$m.t(
                                        'ECビジネス展開全般をサポート'
                                    )}
                                </div>
                                <div className={styles.item}>
                                    {window._$m.t(
                                        '簡易オーダーメイド品作成機能　初心者でもOK'
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* 进群学习 */}
                    {/* <div className={styles.groupLearning}>
                        <div className={styles.mascot}>
                            <img
                                className={styles.pic}
                                src="https://static-s.theckb.com/BusinessMarket/Easy/PC/mascot.png"
                                alt="mascot"
                            />
                            <div className={styles.bubbleContainer}>
                                <div className={styles.content}>
                                    <p>
                                        {window._$m.t(
                                            '进群学习代采模式～精选商品，透明低价！还有更多好物上新提醒！数量有限，先到先得！'
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="relative">
                            <img
                                className={styles.codeBg}
                                src="https://static-s.theckb.com/BusinessMarket/Easy/PC/code.png"
                                alt="code"
                            />
                            <img
                                className={styles.code}
                                src="https://static-s.theckb.com/BusinessMarket/Easy/PC/QRCode.png"
                                alt="code"
                            />
                        </div>
                     </div> */}
                    {/* 是否询问 */}
                    {Boolean(customerDetail?.membership?.templateLevel) && (
                        <Checkbox
                            className={styles.enquire}
                            onChange={(e) =>
                                setCheckboxSelected(e.target.checked)
                            }
                            checked={checkboxSelected}
                        >
                            {window._$m.t('下次自动跳转代采，无需询问')}
                        </Checkbox>
                    )}
                    {/* 跳转按钮 */}
                    <div>
                        <Button
                            onClick={stayCurrent}
                            size="large"
                            className="hover:opacity-80"
                            style={{
                                borderRadius: '20px',
                                marginRight: '28px',
                                minWidth: '139px',
                                fontSize: '14px',
                                fontWeight: '600',
                                color: '#838383',
                                borderColor: '#838383'
                            }}
                        >
                            <span>{window._$m.t('留在直采')}</span>
                        </Button>
                        <Button
                            size="large"
                            className="hover:opacity-80"
                            onClick={toAgent}
                            style={{
                                borderRadius: '20px',
                                minWidth: '139px',
                                fontSize: '14px',
                                color: '#fff',
                                borderColor: '#FF5010',
                                background:
                                    'linear-gradient(90deg, #FF7E3E 0%, #FF5010 50%, #FE4B0F 100%)'
                            }}
                        >
                            <span>{window._$m.t('前往代采')}</span>
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
};
export default ToAgentProcurement;
